const shader = `
#define PRECISION 0.0001

uniform bool gpuPicker;

varying vec2 vUv;
varying float vSelected;
varying vec4 vGPUColor;
varying float vHidden;
varying float vVisible;
varying float vMarkerShape;

bool compareFloat(float floatOne, float floatTwo) {
    return abs(floatOne - floatTwo) < PRECISION;
}

void main() {
    vec2 uv = vUv;
    uv = 2.0 * uv - 1.0;

    bool isHidden = compareFloat(vHidden, 1.0);
    bool isSelected = compareFloat(vSelected, 1.0);
    bool isVisible = compareFloat(vVisible, 1.0);
    bool isCircle = compareFloat(vMarkerShape, 0.0);
    bool isSquare = compareFloat(vMarkerShape, 1.0);

    if (isHidden) {
        discard;
    }

    if (!isVisible) {
        discard;
    }

    // All markers are gray-ish
    vec4 colorStandard = vec4(255, 255, 255, 255) / 255.0;
    vec4 colorSelected = vec4(255, 195, 0, 255) / 255.0;
    float border_thickness = 0.1;

    vec4 final;
    if (gpuPicker) {
        final = vGPUColor;
    } else {
        if (isSelected) {
            final = colorSelected;
        }
        else {
            final = colorStandard;
        }
    }

    // Circular markers
    if (isCircle) {
        // Circle shape
        float circle = sqrt(uv.x * uv.x + uv.y * uv.y);
        float circle_bounds = 1.0;
        if (circle > circle_bounds){
            discard;
        }

        if (!gpuPicker) {
            // Black outline
            float edge = circle_bounds - border_thickness;
            if ((circle <= circle_bounds) && (circle > edge)){
                final.rgb = vec3(0.0, 0.0, 0.0);
            }
        }
    }

    // Square with rounded corners
    if (isSquare) {
        float circle = sqrt(uv.x * uv.x + uv.y * uv.y);
        float circle_bounds = sqrt(2.0) * 0.95;
        if (circle > circle_bounds){
            discard;
        }

        if (!gpuPicker) {
            // Black outline
            float edge1 = circle_bounds - border_thickness;
            float edge2 = 1.0 - border_thickness;
            if ((circle > edge1) || (abs(uv.x) > edge2) || (abs(uv.y) > edge2)) {
                final.rgb = vec3(0.0, 0.0, 0.0);
            }
        }
    }

    if (!gpuPicker) {
        if (final.a < PRECISION) {
            discard;
        }
        final.a = 1.0;
    }

    gl_FragColor = final;
}
`;

export default shader;